export enum DeckStatus {
  PendingUpload = 'PendingUpload',
  Preprocessing = 'Preprocessing',
  Ready = 'Ready',
  Generating = 'Generating',
  Complete = 'Complete',
  Failed = 'Failed'
}
